import { render } from "./UnityGame.vue?vue&type=template&id=1f54f752"
import script from "./UnityGame.vue?vue&type=script&lang=js"
export * from "./UnityGame.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__